
import React, { useEffect, useState } from 'react';
import { Fragment } from 'react';
import Loader from '../../loader/Loader';
import Footer from '../Footer/Footer';
import CookiePolicy from './CookiePolicy';
import PageSEO from '../Common/PageSEO';
import { useLocale } from '../../localization/LocaleContext';

function CookiePolicyMain() {
    const { t, locale } = useLocale();
   const[loader, SetLoader] = useState(false)
    useEffect(() => {
        const timer = setTimeout(() => {
            SetLoader(true)
        },1500)

        return () => clearTimeout(timer)
    }, [])
    if (!loader) {
        return <Loader/>;
    }
    return(
        <Fragment>
            <PageSEO title={t('meta.cookiePolicyTitle')} description={t('meta.cookiePolicyDescription')} path="/cookie-policy" locale={locale} />
            <CookiePolicy/>
            <Footer/>
        </Fragment>
    )
    
}

export default CookiePolicyMain;